<template>
  <div>
    <div v-if="label">
      <slot name="label">
        <label class="control-label">
          {{ label }}
        </label>
      </slot>
    </div>
    <slot>
      <select v-model="item" style="width: 80%">
        <option v-for="(obj, index) in items" :value="obj" :key="index">{{ obj.code ? (obj.name + ' (' + obj.code + ')') : obj.name}}</option>
      </select>
    </slot>
  </div>
</template>

<script>
export default {
  props:{
    object: null,
    type: null,
    label: null,
    page: null,
    class: null,
    style: null,
    index: null,
    itemsData: null
  },
  data(){
    return{
      items: [],
      item: null
    };
  },
  async mounted() {
    this.items = [];
    if (this.itemsData) {
      this.items = this.itemsData;
    } else if (this.page) {
      await this.updatePage();
    } else {
      await this.$repo.getAll(this.items, this.type);
    }
    if (this.object) {
      this.items.forEach(itm => {
        if (itm.value === this.object) {
          this.item = itm;
        }
      });
    }
  },
  methods: {
    async updatePage() {
      if (this.page) {
        let tmpArray = [];
        let prepared = [];
        this.items = [];
        await this.$repo.getPage(this.page, tmpArray, this.type);
        tmpArray.forEach(it => prepared.push(it.object));
        this.items = prepared;
      }
    },
  },
  watch: {
    item: function () {
      this.$emit('update', this.item, this.index);
    },
    object: function(value) {
      if (!value) {
        this.item = null;
      }
    },
    page: function (newVal, oldVal) {
      if (this.page) {
        this.updatePage();
      }
    }
  }
}
</script>

<style>
</style>
